// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'shipments.vincularFrente.title': 'Vincular frentes do ERP',
    'shipments.vincularFrente.descricao': 'Escolha a frente do Protheus desta frente de trabalho. O subcontrato de transporte e a planilha de campo que ela nomeia são vinculados juntos. Quando o ERP abriu transporte e campo em duas frentes irmãs, vincule as duas: o Hub trata as duas como uma frente só.',
    'shipments.vincularFrente.vinculadas': 'Frentes do ERP já vinculadas',
    'shipments.vincularFrente.frente': 'Frente do Protheus',
    'shipments.vincularFrente.acrescentar': 'Acrescentar outra frente do Protheus',
    'shipments.vincularFrente.buscarFrente': 'Buscar por número, apelido ou cliente…',
    'shipments.vincularFrente.vincular': 'Vincular',
    'shipments.vincularFrente.desvincular': 'Desvincular',
    'shipments.vincularFrente.vinculada': 'Frente vinculada. Agora equipare as viagens.',
    'shipments.vincularFrente.desvinculada': 'Vínculo com a frente {{num}} desfeito, junto com o trilho que ela trouxe.',
    'shipments.vincularFrente.trilho.tms': 'Trouxe o transporte',
    'shipments.vincularFrente.trilho.gct': 'Trouxe o campo',
    'shipments.vincularFrente.trilho.ambos': 'Trouxe os dois trilhos',
    'shipments.vincularFrente.trilho.nenhum': 'Só o número',
    'shipments.vincularFrente.ladoCampo': 'Campo',
    'shipments.vincularFrente.ladoTransporte': 'Transporte',
    'shipments.vincularFrente.jaVinculadaAqui': 'Já vinculada a esta frente de trabalho',
    'shipments.vincularFrente.jaVinculadaEm': 'Já é a frente de trabalho {{contrato}}',
  },
  en: {
    'shipments.vincularFrente.title': 'Link ERP fronts',
    'shipments.vincularFrente.descricao': 'Pick the Protheus front for this work front. The transport subcontract and the field sheet it names are linked together. When the ERP opened transport and field as two sibling fronts, link both: the Hub treats them as a single work front.',
    'shipments.vincularFrente.vinculadas': 'ERP fronts already linked',
    'shipments.vincularFrente.frente': 'Protheus front',
    'shipments.vincularFrente.acrescentar': 'Add another Protheus front',
    'shipments.vincularFrente.buscarFrente': 'Search by number, alias or customer…',
    'shipments.vincularFrente.vincular': 'Link',
    'shipments.vincularFrente.desvincular': 'Unlink',
    'shipments.vincularFrente.vinculada': 'Front linked. Now match the trips.',
    'shipments.vincularFrente.desvinculada': 'Link with front {{num}} removed, along with the track it brought.',
    'shipments.vincularFrente.trilho.tms': 'Brought the transport',
    'shipments.vincularFrente.trilho.gct': 'Brought the field',
    'shipments.vincularFrente.trilho.ambos': 'Brought both tracks',
    'shipments.vincularFrente.trilho.nenhum': 'Number only',
    'shipments.vincularFrente.ladoCampo': 'Field',
    'shipments.vincularFrente.ladoTransporte': 'Transport',
    'shipments.vincularFrente.jaVinculadaAqui': 'Already linked to this work front',
    'shipments.vincularFrente.jaVinculadaEm': 'Already work front {{contrato}}',
  },
  es: {
    'shipments.vincularFrente.title': 'Vincular frentes del ERP',
    'shipments.vincularFrente.descricao': 'Elige el frente de Protheus de este frente de trabajo. El subcontrato de transporte y la planilla de campo que nombra se vinculan juntos. Cuando el ERP abrió transporte y campo en dos frentes hermanos, vincula los dos: el Hub los trata como un solo frente.',
    'shipments.vincularFrente.vinculadas': 'Frentes del ERP ya vinculados',
    'shipments.vincularFrente.frente': 'Frente de Protheus',
    'shipments.vincularFrente.acrescentar': 'Agregar otro frente de Protheus',
    'shipments.vincularFrente.buscarFrente': 'Buscar por número, alias o cliente…',
    'shipments.vincularFrente.vincular': 'Vincular',
    'shipments.vincularFrente.desvincular': 'Desvincular',
    'shipments.vincularFrente.vinculada': 'Frente vinculado. Ahora equipara los viajes.',
    'shipments.vincularFrente.desvinculada': 'Vínculo con el frente {{num}} deshecho, junto con la vía que trajo.',
    'shipments.vincularFrente.trilho.tms': 'Trajo el transporte',
    'shipments.vincularFrente.trilho.gct': 'Trajo el campo',
    'shipments.vincularFrente.trilho.ambos': 'Trajo las dos vías',
    'shipments.vincularFrente.trilho.nenhum': 'Solo el número',
    'shipments.vincularFrente.ladoCampo': 'Campo',
    'shipments.vincularFrente.ladoTransporte': 'Transporte',
    'shipments.vincularFrente.jaVinculadaAqui': 'Ya vinculado a este frente de trabajo',
    'shipments.vincularFrente.jaVinculadaEm': 'Ya es el frente de trabajo {{contrato}}',
  },
}
